module.exports = __webpack_public_path__ + "static/img/14.29ebec4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/14.png
// module id = hwf2
// module chunks = 0